module.exports = __webpack_public_path__ + "images/petal_bg.477e4afd.svg";